import { render, staticRenderFns } from "./ReceivableAdjustmentEdit.vue?vue&type=template&id=4abd9e1a&scoped=true&"
import script from "./ReceivableAdjustmentEdit.vue?vue&type=script&lang=js&"
export * from "./ReceivableAdjustmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd9e1a",
  null
  
)

export default component.exports